import { useState } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config.js";
import { useUser } from "../config/userProvider.js";
import { useNavigate } from "react-router-dom";
import OrderLookup from "../components/orderLookup.js";
import { CATEGORY_MAP } from "../json/categoryMap.js";
import { PRODUCT_LIST } from "../json/productList.js";

// const CATEGORY_MAP = {
//   behaviour_issue: {
//     label: "Behaviour Issue",
//     subs: [
//       { key: "rude_tone", label: "Rude Tone" },
//       { key: "abusive", label: "Abusive" },
//     ],
//   },
//   delivery_issue: {
//     label: "Delivery Issue",
//     subs: [
//       { key: "delay_delivery", label: "Delay Delivery" },
//       { key: "india_post", label: "India Post" },
//       { key: "online_order", label: "Online Order" },
//       { key: "delivery_issue", label: "Delivery Issue" },
//     ],
//   },
//   product_complaint: {
//     label: "Product Complaint",
//     subs: [
//       { key: "medicine_not_effective", label: "Medicine Not Effective" },
//       { key: "product_quality_issue", label: "Product Quality Issue" },
//       { key: "quantity_issue", label: "Quantity Issue" },
//       { key: "manufacturing_issue", label: "Manufacturing Issue" },
//       { key: "wrong_product", label: "Wrong Product" },
//       { key: "missing_product", label: "Missing Product" },
//     ],
//   },
//   payment_refund_request: {
//     label: "Payment Refund Request",
//     subs: [
//       { key: "refund_not_received", label: "Refund Not Received" },
//       { key: "payment_failed", label: "Payment Failed" },
//     ],
//   },
//   need_to_talk: { label: "Need to Talk", subs: [] },
//   number_block_request: { label: "Number Block Request", subs: [] },
//   wrong_punch_or_info: {
//     label: "Wrong Punch / Wrong Medicine Info",
//     subs: [
//       { key: "wrong_punch", label: "Wrong Punch" },
//       {
//         key: "wrong_medicine_information",
//         label: "Wrong Medicine Information",
//       },
//     ],
//   },
//   technical_glitch: {
//     label: "Technical Glitch",
//     subs: [
//       {
//         key: "payment_done_but_order_missing",
//         label: "Payment Done But Order Missing",
//       },
//     ],
//   },
//   other: { label: "Other", subs: [{ key: "other", label: "Other" }] },
// };

const normalizeIndianMobile = (phone) => {
  if (!phone) return "";

  // remove everything except digits
  let digits = phone.replace(/\D/g, "");

  // remove leading 0
  if (digits.startsWith("0")) {
    digits = digits.substring(1);
  }

  // remove country code 91
  if (digits.startsWith("91") && digits.length > 10) {
    digits = digits.substring(digits.length - 10);
  }

  // final validation
  if (digits.length !== 10) return "";

  return digits;
};

export default function CreateTicket() {
  const { userData } = useUser();

  console.log("userData in create ticket :", userData);

  const [form, setForm] = useState({
    subject: "",
    description: "",
    category: "",
    subcategory: "",
    priority: "medium",
    channel: "call-center",

    customerName: "",
    customerPhone: "",
    customerEmail: "",

    requesterId: "",
    orderId: "",
    productName: "",

    isOrderDelivered: false,
  });

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchingOrder, setFetchingOrder] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  console.log("order :", order);

  // const handleChange = (e) => {
  //   setForm({ ...form, [e.target.name]: e.target.value });
  // };

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const fetchOrder = async () => {
    if (!form.orderId) {
      return setError("Enter Order Number");
    }

    try {
      setFetchingOrder(true);
      setError(null);

      const res = await axios.get(
        `${apiurl}/services/shopify/getShopifyOrderByNumber/${form.orderId}`,
      );

      const o = res.data.order;

      // 🔥 normalize Shopify → internal format
      const normalizedOrder = {
        isOrderDelivered: form.isOrderDelivered,
        orderId: o.name, // "#3582383"
        shopifyOrderId: o.id,
        orderDate: o.created_at,
        amount: o.current_total_price,
        paymentMode: o.payment_gateway_names?.join(", "),
        paymentStatus: o.financial_status,
        deliveryStatus: o.fulfillment_status,
        deliveryPartner: o.fulfillments?.[0]?.tracking_company,
        trackingId: o.fulfillments?.[0]?.tracking_number,
        trackingUrl: o.fulfillments?.[0]?.tracking_url,
        raw: o, // keep full Shopify order (VERY IMPORTANT)
      };

      setOrder(normalizedOrder);

      // 🔥 Autofill customer
      setForm((f) => ({
        ...f,
        customerName: o.billing_address?.name || o.shipping_address?.name || "",
        customerPhone:
          o.billing_address?.phone || o.shipping_address?.phone || "",
        customerEmail: o.email || "",
      }));
    } catch (err) {
      setOrder(null);
      setError("Order not found");
    } finally {
      setFetchingOrder(false);
    }
  };

  const generateSubject = (category, subcategory) => {
    if (!category) return "";

    const catLabel = CATEGORY_MAP[category]?.label;
    const subLabel = CATEGORY_MAP[category]?.subs.find(
      (s) => s.key === subcategory,
    )?.label;

    return subLabel ? `${catLabel} - ${subLabel}` : catLabel;
  };

  // 🔹 Create Ticket
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);

    // 🔥 COMPUTE HERE — always latest state
    const cleanPhone = normalizeIndianMobile(
      form.customerPhone ||
        order?.phone ||
        order?.customer?.phone ||
        order?.raw?.phone,
    );

    try {
      const payload = {
        subject: form.subject,
        description: form.description,
        category: form.category,
        subcategory: form.subcategory,
        priority: form.priority,
        channel: form.channel,

        userObjId: userData._id || undefined,

        customer: {
          name: form.customerName,
          phone: cleanPhone || undefined,
          email: form.customerEmail,
        },

        // ✅ PRODUCT SPECIFIC FIELDS
        productName:
          form.category === "product_complaint" ? form.productName : undefined,

        primaryRootCause:
          form.category === "product_complaint" ? form.subcategory : undefined,

        order: order
          ? {
              orderId: order.orderId,
              shopifyOrderId: order.shopifyOrderId,
              orderDate: order.orderDate,
              amount: order.amount,
              paymentMode: order.paymentMode,
              paymentStatus: order.paymentStatus,
              deliveryStatus: order.deliveryStatus,
              deliveryPartner: order.deliveryPartner,
              trackingId: order.trackingId,
              trackingUrl: order.trackingUrl,
              // raw: order.raw, // 🔥 FULL SHOPIFY ORDER STORED
            }
          : undefined,
      };

      console.log("payload", payload);

      const res = await axios.post(`${apiurl}/api/cst/create`, payload);

      setSuccess(`Ticket Created: ${res.data.ticket.ticketId}`);
      navigate(`/tickets/${res.data.ticket._id}`);
      setForm({
        subject: "",
        description: "",
        category: "",
        subcategory: "",
        priority: "medium",
        channel: "call-center",
        customerName: "",
        customerPhone: "",
        customerEmail: "",
        requesterId: "",
        orderId: "",
      });
      setOrder(null);
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };


  console.log("form", form);
  return (
    <Layout>
      <Container overflow="overflow-scroll">
        <div className="bg-gray-50 flex items-center justify-center p-4">
          <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-3xl">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
              Create Support Ticket
            </h2>

            {success && (
              <div className="mb-4 p-3 rounded bg-green-50 text-green-700 text-sm">
                {success}
              </div>
            )}
            {error && (
              <div className="mb-4 p-3 rounded bg-red-50 text-red-700 text-sm">
                {error}
              </div>
            )}

            <label className="flex items-center justify-between mb-4">
              <span className="text-sm font-medium text-gray-700">
                Order Delivered
              </span>

              <div
                onClick={() =>
                  setForm((prev) => ({
                    ...prev,
                    isOrderDelivered: !prev.isOrderDelivered,
                  }))
                }
                className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition ${
                  form.isOrderDelivered ? "bg-green-500" : "bg-gray-300"
                }`}
              >
                <div
                  className={`bg-white w-4 h-4 rounded-full shadow-md transform transition ${
                    form.isOrderDelivered ? "translate-x-6" : ""
                  }`}
                ></div>
              </div>
            </label>

            {/* <OrderLookup/> */}

            <OrderLookup
              onOrderFetched={(orderData) => {
                setOrder(orderData);

                if (!orderData) return;

                // 🔥 Auto-fill customer details
                // setForm((f) => ({
                //   ...f,
                //   orderId: orderData.orderId,
                //   customerName: orderData.customer.name,
                //   customerPhone: orderData?.customer?.phone || orderData?.phone || orderData.billing_address.phone || orderData.shipping_address.phone,
                //   customerEmail: orderData.customer.email,
                // }));

                const rawPhone =
                  orderData?.phone ||
                  orderData?.customer?.phone ||
                  orderData?.billing_address?.phone ||
                  orderData?.shipping_address?.phone ||
                  "";

                setForm((f) => ({
                  ...f,
                  orderId: orderData.orderId,
                  customerName: orderData.customer?.name || "",
                  customerPhone: normalizeIndianMobile(rawPhone),
                  customerEmail: orderData.customer?.email || "",
                }));
              }}
            />

            {/* 📝 Ticket Form */}
            <form onSubmit={handleSubmit} className="space-y-5 mt-3">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  placeholder="Subject"
                  className="input"
                  required
                />

                <select
                  name="priority"
                  value={form.priority}
                  onChange={handleChange}
                  className="input"
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="critical">Critical</option>
                </select>
              </div>

              {/* Category */}
              {/* <select
                name="category"
                value={form.category}
                onChange={(e) =>
                  setForm({
                    ...form,
                    category: e.target.value,
                    subcategory: "",
                    
                  })
                }
                className="input"
                required
              > */}
              <select
                name="category"
                value={form.category}
                onChange={(e) => {
                  const category = e.target.value;
                  setForm((f) => ({
                    ...f,
                    category,
                    subcategory: "",
                    productName: "",
                    subject: generateSubject(category, ""),
                  }));
                }}
                className="input"
                required
              >
                <option value="">Select Complaint Type</option>
                {Object.entries(CATEGORY_MAP).map(([key, obj]) => (
                  <option key={key} value={key}>
                    {obj.label}
                  </option>
                ))}
              </select>

              {/* Subcategory */}
              {/* <select
                name="subcategory"
                value={form.subcategory}
                onChange={handleChange}
                className="input" */}
              <select
                name="subcategory"
                value={form.subcategory}
                onChange={(e) => {
                  const subcategory = e.target.value;
                  setForm((f) => ({
                    ...f,
                    subcategory,
                    subject: generateSubject(f.category, subcategory),
                  }));
                }}
                className="input"
                disabled={
                  !form.category ||
                  CATEGORY_MAP[form.category]?.subs.length === 0
                }
                required={CATEGORY_MAP[form.category]?.subs.length > 0}
              >
                <option value="">
                  {CATEGORY_MAP[form.category]?.subs.length
                    ? "Select Sub Complaint"
                    : "No Sub Complaint"}
                </option>
                {CATEGORY_MAP[form.category]?.subs.map((sub) => (
                  <option key={sub.key} value={sub.key}>
                    {sub.label}
                  </option>
                ))}
              </select>

              {/* Product Select (Only for Product Complaint) */}
              {form.category === "product_complaint" ? (
                <select
                  name="productName"
                  value={form.productName}
                  onChange={handleChange}
                  className="input"
                  required
                >
                  <option value="">Select Product</option>
                  {PRODUCT_LIST.map((item) => (
                    <option key={item?.key} value={item?.label}>
                      {item.label}
                    </option>
                  ))}
                </select>
              ) : null}

              <textarea
                name="description"
                value={form.description}
                onChange={handleChange}
                placeholder="Describe the issue"
                className="input h-28"
                required
              />

              {/* Customer */}
              <div className="border-t pt-5">
                <h3 className="text-lg font-medium mb-3">Customer Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <input
                    name="customerName"
                    value={form.customerName}
                    onChange={handleChange}
                    placeholder="Customer Name"
                    className="input"
                    required
                  />
                  {/* <input
                    name="customerPhone"
                    value={form.customerPhone}
                    onChange={handleChange}
                    placeholder="Phone"
                    className="input"
                  /> */}
                  <input
                    name="customerEmail"
                    value={form.customerEmail}
                    onChange={handleChange}
                    placeholder="Email"
                    className="input"
                  />
                </div>
              </div>

              {/* Internal */}
              <div className="border-t pt-5">
                <h3 className="text-lg font-medium mb-3">Internal Requester</h3>
                <input
                  name="requesterId"
                  readOnly
                  className="input bg-gray-100 cursor-not-allowed uppercase"
                  value={
                    userData?.firstName +
                      " " +
                      userData?.lastName +
                      " (SUW" +
                      userData?.employeeDetails?.employeeId +
                      ")" || ""
                  }
                  onChange={handleChange}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded-xl font-medium transition"
              >
                {loading ? "Creating..." : "Create Ticket"}
              </button>
            </form>
          </div>

          <style jsx>{`
            .input {
              width: 100%;
              padding: 0.75rem 1rem;
              border: 1px solid #e5e7eb;
              border-radius: 0.75rem;
              font-size: 0.95rem;
              outline: none;
            }
            .input:focus {
              border-color: #6366f1;
              box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
            }
          `}</style>
        </div>
      </Container>
    </Layout>
  );
}
